export const SERVICE_CATEGORIES = [
  { v: "professional", ar: "خدمات مهنية", en: "Professional",
    subs: ["lawyer", "immigration_lawyer", "accountant", "tax_preparer", "insurance_agent", "real_estate_agent", "mortgage_broker"] },
  { v: "healthcare", ar: "صحة", en: "Healthcare",
    subs: ["doctor", "dentist", "pharmacist", "physical_therapist", "mental_health"] },
  { v: "education", ar: "تعليم", en: "Education",
    subs: ["arabic_teacher", "quran_teacher", "islamic_studies", "english_tutor", "math_tutor", "science_tutor", "sat_tutor"] },
  { v: "home", ar: "خدمات منزلية", en: "Home Services",
    subs: ["plumber", "electrician", "carpenter", "painter", "handyman", "hvac", "movers"] },
  { v: "auto", ar: "خدمات سيارات", en: "Automotive",
    subs: ["mechanic", "auto_body", "car_inspector", "tire_service"] },
  { v: "food_home_business", ar: "طعام ومشاريع منزلية", en: "Food & Home Business",
    subs: ["home_cooking", "catering", "homemade_desserts", "bakery_services", "meal_prep"] },
  { v: "creative", ar: "خدمات إبداعية", en: "Creative",
    subs: ["graphic_designer", "photographer", "videographer", "social_media_manager"] }
];

export const SUB_LABELS = {
  lawyer: { ar: "محامي", en: "Lawyer" },
  immigration_lawyer: { ar: "محامي هجرة", en: "Immigration Lawyer" },
  accountant: { ar: "محاسب", en: "Accountant" },
  tax_preparer: { ar: "محضّر ضرائب", en: "Tax Preparer" },
  insurance_agent: { ar: "وكيل تأمين", en: "Insurance Agent" },
  real_estate_agent: { ar: "وكيل عقاري", en: "Real Estate Agent" },
  mortgage_broker: { ar: "وسيط رهن عقاري", en: "Mortgage Broker" },
  doctor: { ar: "طبيب", en: "Doctor" },
  dentist: { ar: "طبيب أسنان", en: "Dentist" },
  pharmacist: { ar: "صيدلي", en: "Pharmacist" },
  physical_therapist: { ar: "علاج طبيعي", en: "Physical Therapist" },
  mental_health: { ar: "صحة نفسية", en: "Mental Health" },
  arabic_teacher: { ar: "معلم عربي", en: "Arabic Teacher" },
  quran_teacher: { ar: "معلم قرآن", en: "Quran Teacher" },
  islamic_studies: { ar: "دراسات إسلامية", en: "Islamic Studies" },
  english_tutor: { ar: "مدرس إنجليزي", en: "English Tutor" },
  math_tutor: { ar: "مدرس رياضيات", en: "Math Tutor" },
  science_tutor: { ar: "مدرس علوم", en: "Science Tutor" },
  sat_tutor: { ar: "مدرس SAT", en: "SAT Tutor" },
  plumber: { ar: "سبّاك", en: "Plumber" },
  electrician: { ar: "كهربائي", en: "Electrician" },
  carpenter: { ar: "نجار", en: "Carpenter" },
  painter: { ar: "دهّان", en: "Painter" },
  handyman: { ar: "صنايعي عام", en: "Handyman" },
  hvac: { ar: "تكييف", en: "HVAC" },
  movers: { ar: "نقل عفش", en: "Movers" },
  mechanic: { ar: "ميكانيكي", en: "Mechanic" },
  auto_body: { ar: "تصليح هيكل", en: "Auto Body" },
  car_inspector: { ar: "فحص سيارات", en: "Car Inspector" },
  tire_service: { ar: "إطارات", en: "Tire Service" },
  home_cooking: { ar: "طبخ منزلي", en: "Home Cooking" },
  catering: { ar: "ضيافة", en: "Catering" },
  homemade_desserts: { ar: "حلويات منزلية", en: "Homemade Desserts" },
  bakery_services: { ar: "مخبوزات", en: "Bakery Services" },
  meal_prep: { ar: "وجبات جاهزة", en: "Meal Prep" },
  graphic_designer: { ar: "مصمم جرافيك", en: "Graphic Designer" },
  photographer: { ar: "مصوّر", en: "Photographer" },
  videographer: { ar: "مصوّر فيديو", en: "Videographer" },
  social_media_manager: { ar: "إدارة سوشيال ميديا", en: "Social Media Manager" }
};

export const subLabel = (v, lang) => (SUB_LABELS[v] ? (lang === "ar" ? SUB_LABELS[v].ar : SUB_LABELS[v].en) : v);
export const catLabel = (v, lang) => {
  const c = SERVICE_CATEGORIES.find((x) => x.v === v);
  return c ? (lang === "ar" ? c.ar : c.en) : v;
};
